import React, { useEffect } from 'react';
import AboutBanner from "../Components/About/AboutBanner";
import AboutContent from "../Components/About/AboutContent";
import Footer from "../Components/Footer/Footer";

import Navigation from "../Components/Navbar/Navigation";
import UserNavigation from '../Components/v1/NavBar/Navigaton';
import {Helmet} from "react-helmet";
import AboutUs from '../Components/v1/Home/AboutUs';
import ServicesCount from '../Components/v1/Services/ServicesCount';
import Newsletter from '../Components/v1/Home/Newletter';
import AppDownload from '../Components/v1/Home/AppDownload';
import ScheduleMeetBanner from '../Components/v1/Home/ScheduleMeetBanner';
export default function About() {
     useEffect(() =>{
    window.scroll(0,0)
  },[])

 

  return (
    <div className="innerpages-nav">
      <Helmet>
          <meta charSet="utf-8" />
          <title>About DALMaf Private Limited</title>
          <link rel="canonical" href={window.location.href} />
          <meta name="description" content="We are happy to Introduce the Dalmaf Company, the one-stop destination for Legal, Auditing, Bank Auction Support, Buying and Selling, and Marketing Assistance. Founded in June of 2022 as a Global Market Pioneer for offering comprehensive company solutions in all aspects, Our team of Professionals is Passionate about aiding businesses in Resolving Difficulties, Strengthening their Internal Operations, and Realising their ultimate goal." />
          <meta name="keywords" content="We are happy to Introduce the Dalmaf Company, the one-stop destination for Legal, Auditing, Bank Auction Support, Buying and Selling, and Marketing Assistance. Founded in June of 2022 as a Global Market Pioneer for offering comprehensive company solutions in all aspects, Our team of Professionals is Passionate about aiding businesses in Resolving Difficulties, Strengthening their Internal Operations, and Realising their ultimate goal." />
          <meta name="author" content="DALMaf" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
      </Helmet>
      
     
      <div id="container" >
        <UserNavigation/>
        {/* <Navigation /> */}
        {/* <AboutBanner /> */}
        <div style={{marginTop:"-25px"}}>
        <AboutUs/>
        </div>
        <ServicesCount/>
        <AboutContent />
        <ScheduleMeetBanner/>
        {/* <AppDownload/> */}
        <Newsletter/>
        <Footer />
      </div>
    </div>
  );
}
